module.exports = __webpack_public_path__ + "static/media/iot3.694eeb73.svg";